var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('img',{attrs:{"src":require('@/assets/publicis.png'),"width":"80"}}),_c('p',[_vm._v("No results found")])])])}
var staticRenderFns = []

export { render, staticRenderFns }